let React =            require("react");

let DataListPage =     require("../../pages/generic/DataListPage.jsx");
let EmptyLibraryCard = require("../empty/EmptyLibraryCard.jsx");
let ImportLibraries =  require("../importLibrary/ImportLibraries.jsx");
let LibraryCard =      require("../cards/LibraryCard.jsx");

class LibrariesHub extends React.Component {

    shouldComponentUpdate(nextProps){
        return  Number(this.props.hub.id) !== Number(nextProps.hub.id) ||
                Boolean(this.props.hub.deleted) !== Boolean(nextProps.hub.deleted)
    }

    render() {

        const hubDeleted = Boolean(this.props.hub.deleted);

        const WrappedImportLibraries = props => <ImportLibraries {...props} idHub={this.props.hub.id} handleError={this.props.handleError}/>;
        const WrappedLibraryCard = props => <LibraryCard {...props} hubDeleted={hubDeleted}/>;
        const WrappedEmptyLibraryCard = props => <EmptyLibraryCard {...props} idHub={this.props.hub.id}/>;

        return  <DataListPage
                    {...this.props}
                    cssCardTag="library"
                    urlName="libraries"
                    displayName={`Libraries from "${this.props.hub.name}"`}
                    endpoint="/libraries/search?"
                    filtersEndpoint={{hub: this.props.hub.id}}
                    loginRequired
                    canSwitchLayout
                    resetViewAfterNewUpload
                    showUploadNewAsset={!hubDeleted}
                    UploadNewAsset={WrappedImportLibraries}
                    uploadContentIsAboveTitle
                    EmptyCard={WrappedEmptyLibraryCard}
                    CardType={WrappedLibraryCard}
                />
    }
}

module.exports = LibrariesHub;
